// removed by extract-text-webpack-plugin
module.exports = {"divWrapper":"_2MtjHMW0K2_CzEMgP4UhFX","headerBar":"_10VGgPS3RLvt4uSgnvG2AX","text":"_29DFy7SoPZrzppJ61prWDa","icon":"_2jrKUKVVkksPyIcXiTB1Xw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModuleWrap/ModuleWrap.css
// module id = 35
// module chunks = 0